module.exports = __webpack_public_path__ + "static/alquilerbuses-0ad1b17f4d8a780764d85cc22fecb990.webp";